<template lang="pug">
  .gvl-check-data
    v-expansion-panels(v-model="panel" accordion tile multiple)
      v-expansion-panel
        v-expansion-panel-header Angaben zur Antragstellerin bzw. dem Antragsteller
        v-expansion-panel-content(eager)
          applicant-information(ref="applicant-info" readonly)

      v-expansion-panel
        v-expansion-panel-header Bankverbindung
        v-expansion-panel-content(eager)
          bank-details(ref="bank-details" readonly)

      v-expansion-panel
        v-expansion-panel-header Angaben zur Förderberechtigung
        v-expansion-panel-content(eager)
          funding-information(ref="funding-info" readonly)

      v-expansion-panel
        v-expansion-panel-header Künstlerisches Konzept
        v-expansion-panel-content(eager)
          artistic-concept(ref="artistic-concept" readonly)

    .mt-8.text-center
      v-btn(color="primary" outlined @click="showPrintDialog = true") Antragsdaten drucken

    v-form.mt-8(ref="check-form" lazy-validation): v-row
      v-col(cols="12")
        p.hint-label.font-weight-bold.mb-1 Abschließende Erklärung
        p.hint-label.mb-0 Die hier getätigten Angaben sowie die Angaben in den beigefügten Anlagen sind vollständig und entsprechen der Wahrheit. Die Fördermittel werden nur zur Erfüllung des in diesem Antrag bestimmten Zweckes verwendet. Alle relevanten Änderungen der beantragten Maßnahme und insbesondere seiner Finanzierung werde ich unverzüglich schriftlich der GVL mitteilen *
        p.hint-label.mb-0 Die Fördermittel werden nur zur Erfüllung des in diesem Antrag bestimmten Zweckes verwendet. Alle relevanten Änderungen müssen unverzüglich der GVL mittgeteilt werden. Mit dem Vorhaben wurde noch nicht begonnen.
        p.hint-label.mb-0 Die beantragten Maßnahmen können nicht ohne BKM-Mittel finanziert werden, auch nicht durch Übernahme einer Bürgschaft, Garantie oder sonstigen Gewährleistung sowie der Gewährung einer rückzahlbaren Zuwendung.
        p.hint-label.mb-0 Mir sind die Tatsachen nach Nr. 3.4.1. bis 3.4.3 der VV zu § 44 Bundeshaushaltsordnung (Link zu BHO) als subventionserheblich und die Strafbarkeit eines Subventionsbetruges nach § 264 Strafgesetzbuch (Link zu StGB) bekannt.

      v-col(cols="12"): v-checkbox(
        v-model="formData.bestaetigung_angaben_korrekt"
        label="Hiermit bestätige ich meine Angaben und versichere, dass ich die Antragsvoraussetzungen zur Kenntnis genommen und alle Angaben nach bestem Wissen und Gewissen sowie wahrheitsgetreu getätigt habe."
        dense
        :rules="[ rules.required ]"
        @input="(v) => saveFieldValue('bestaetigung_angaben_korrekt', v)"
      )

      v-col.pt-0(cols="12"): v-checkbox(
        v-model="formData.bestaetigung_finazbehoerden"
        label="Ich erkläre, dass ich die Finanzbehörden von der Verpflichtung zur Wahrung des Steuergeheimnisses gegenüber den Bewilligungsstellen und den Strafverfolgungsbehörden befreie, soweit es sich um Angaben / Daten handelt, die für die Gewährung der Förderung / des Stipendiums von Bedeutung sind. Dementsprechend nehme ich auch zur Kenntnis, dass die Bewilligungsstellen von den Finanzbehörden Auskünfte über den/die Antragssteller/in einholen dürfen, soweit diese für die Bewilligung, Gewährung, Rückforderung, Erstattung oder Belassen der Hilfe erforderlich sind."
        dense
        :rules="[ rules.required ]"
        @input="(v) => saveFieldValue('bestaetigung_finazbehoerden', v)"
      )

      v-col.pt-0(cols="12"): v-checkbox(
        v-model="formData.bestaetigung_rechtsanspruch"
        label="Ich habe zur Kenntnis genommen, dass kein Rechtsanspruch auf die Förderung bzw. das Stipendium besteht und dass die Förderung bzw. das Stipendium in der Einkommensteuer-/Gewerbesteuererklärung zu erfassen sind. Zudem bestätige ich, dass Steuern und Sozialabgaben ordnungsgemäß abgeführt werden."
        dense
        :rules="[ rules.required ]"
        @input="(v) => saveFieldValue('bestaetigung_rechtsanspruch', v)"
      )

      v-col.pt-0(cols="12"): v-checkbox(
        v-model="formData.bestaetigung_stammdaten_verwenden"
        label="Ich bin damit einverstanden, dass im Rahmen einer bereits bestehenden Geschäftsbeziehung zur GVL für die Antragsbearbeitung die gespeicherten Stammdaten wie Name, Anschrift, E-Mail, GVL-ID, KSK-Nummer, Bankverbindung verwendet werden."
        dense
        :rules="[ rules.required ]"
        @input="(v) => saveFieldValue('bestaetigung_stammdaten_verwenden', v)"
      )

      v-col.pt-0(cols="12"): v-checkbox(
        v-model="formData.bestaetigung_zustellung_dokumente"
        label="Ich bin damit einverstanden, dass die Zustellung von Dokumenten wie Verträgen und Bescheiden ausschließlich digital über die von mir angegebene E-Mail-Adresse erfolgt."
        dense
        :rules="[ rules.required ]"
        @input="(v) => saveFieldValue('bestaetigung_zustellung_dokumente', v)"
      )

      v-col.pt-0(cols="12"): v-checkbox(
        v-model="formData.bestaetigung_datenschutz"
        dense
        :rules="[ rules.required ]"
        @input="(v) => saveFieldValue('bestaetigung_datenschutz', v)"
      )
        .custom-label(slot="label")
          span Hiermit bestätige ich die
          a.ml-2(@click.stop.prevent="showInfoModal = true") Datenschutzerklärung

      v-col.pt-0(cols="12"): v-checkbox(
        v-model="formData.bestaetigung_bundeshaushaltsordnung"
        label="Hiermit bestätige ich, dass mir die Tatsachen nach Nr. 3.4.1. bis 3.4.3 der VV zu § 44 Bundeshaushaltsordnung (BHO) als subventionserheblich und die Strafbarkeit eines Subventionsbetruges nach § 264 Strafgesetzbuch (StGB) bekannt sind."
        dense
        :rules="[ rules.required ]"
        @input="(v) => saveFieldValue('bestaetigung_bundeshaushaltsordnung', v)"
      )

      v-col(cols="12")
        v-btn.mt-3(color="primary" block @click="onSubmit") Antrag absenden

    .overlay-spinner(v-if="loading")
      v-progress-circular(
        :size="60"
        color="#ccc"
        indeterminate
      )

    v-dialog(v-model="showInfoModal" width="600px")
      v-card
        v-card-title
        v-card-text
          | Ihre hier erhobenen personenbezogenen Daten (Namen, Funktionen im Unternehmen, Gesellschafterverhältnisse, Erreichbarkeiten, Anschriften, Auszahlungsdaten) nutzen wir, die Gesellschaft zur Verwertung von Leistungsschutzrechten mbH (GVL), zur Prüfung der Voraussetzungen für eine Zuerkennung einer Bundesförderung aus dem Programm „Neustart Kultur“ der Beauftragten der Bundesregierung für Kultur und Medien (BKM) sowie im Falle einer positiven Entscheidung zur Abwicklung des abzuschließenden Vertrages über die Weiterleitung von Zuwendungen.<br>
          | Im Falle des Abschlusses eines Vertrages mit Ihnen übermitteln wir Ihre Daten an die Beauftragte der Bundesregierung für Kultur und Medien (BKM), Graurheindorfer Straße 198, 53117 Bonn. Zweck der Übermittlung an die BKM ist, der BKM und ggf. dem Bundesrechnungshof die Prüfung der Einhaltung öffentlich-rechtlicher Vorschriften im Rahmen der Bewilligung von Zuwendungen zu ermöglichen.<br>
          | Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 Satz 1 Buchst. b DSGVO bzw. im Falle der Datenverarbeitung durch die BKM und den Bundesrechnungshof auch Art. 6 Abs. 1 Satz 1 Buchst. c DSGVO.<br>
          | Ich bestätige, dass ich der Bewilligungsstelle und sonstigen zuständigen Behörden auf Verlangen die zur Aufklärung des Sachverhalts und Bearbeitung eines Antrags ‚erforderlichen Unterlagen und Informationen unverzüglich zur Verfügung stelle.<br>
          | Für den Fall, dass ein Vertrag über die Weiterleitung von Zuwendungen mit Ihnen nicht zustande kommt, löschen wir Ihre Daten, die zu o.g. Zweck erhoben und gespeichert wurden, sechs Monate oder, wenn das Programm länger als sechs Monate laufen sollte, bis zum Programmabschluss nach unserer ablehnenden Mitteilung an Sie. Sofern ein Vertrag über die Weiterleitung von Zuwendungen mit Ihnen abgeschlossen wird, speichern wir Ihre personenbezogenen Daten, soweit wir gesetzlich dazu verpflichtet sind. Solche Nachweis- und Aufbewahrungspflichten ergeben sich unter anderem aus dem Handelsgesetzbuch, der Bundeshaushaltsordnung oder steuerrechtlichen Vorschriften und sehen Fristen von bis zu zehn Jahren vor. Rechtsgrundlage hierfür ist Art. 6 Abs. 1 Satz 1 Buchst. c DSGVO.

        v-card-actions
          v-btn(color="primary" block outlined @click="showInfoModal = false") Schließen

    v-dialog(v-model="showPrintDialog" width="1200px")
      print-data(@close="showPrintDialog = false")

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'
import Urls from '@/router/urls'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    ApplicantInformation: () => import('@/components/applicant-information'),
    BankDetails: () => import('@/components/bank-details'),
    FundingInformation: () => import('@/components/funding-information'),
    ArtisticConcept: () => import('@/components/artistic-concept'),
    PrintData: () => import('@/components/print-data'),
  }
})
export default class CheckData extends Vue {
  panel = [ 0, 1, 2, 3 ]
  loading = false
  showInfoModal = false
  showPrintDialog = false

  onSubmit () {
    const formChecks = this.$refs['check-form']
    if (!formChecks.validate()) {
      return
    }

    const params = new FormData()

    Object.keys(this.formData)
      .forEach(k => {
        let value = this.formData[k]
        if (k === 'berufsanfaenger' && value === null) {
          return
        }

        if (k === 'geburtstag') {
          value = this.formatDateTime(value, 'YYYY-MM-DD')
        } else if (k === 'bank_iban' || k === 'bank_bic') {
          value = value.toString().toUpperCase()
        } else if (k === 'telefon') {
          value = `+49 ${ value }`
        }
        params.append(k, value)
      })

    params.append('token', this.inputsToken)

    this.loading = true
    this.setFileError(null)

    this.$axios
      .post(Urls.NewAntrag, params)
      .then(() => {
        this.$toast.success('Success', 'Succesfully saved')
        this.$emit('next')
        this.setFinished(true)
        this.$store.dispatch('resetFormData')
      })
      .catch(err => {
        if (err.code) {
          this.setFileError(err)
            .then(() => {
              this.$emit('file-error')
            })
        } else {
          this.$toast.error('Fehler', err.message || 'Failed to save data')
        }
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
